<div class="flex flex-col gap-4 pt-4">
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">Complexity</div>
    <div class="text-base">{{ complexityLabel }}</div>
  </div>

  <!-- Solid Volume -->
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">Solid Volume</div>
    <div class="text-base">
      @if (cadObject.solid_volume !== null) {
        <div>
          {{ formatCadVolume(cadObject.solid_volume, "m³") }}
          <span class="text-sm text-muted-color ml-1">m³</span>
        </div>
        <div>
          {{ formatCadVolume(cadObject.solid_volume, "cm³") }}
          <span class="text-sm text-muted-color ml-1">cm³</span>
        </div>
        <div>
          {{ formatCadVolume(cadObject.solid_volume, "mm³") }}
          <span class="text-sm text-muted-color ml-1">mm³</span>
        </div>
      } @else {
        N/A
      }
    </div>
  </div>

  <!-- Surface Area -->
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">Surface Area</div>
    <div class="text-base">
      {{
        cadObject.surface_area !== null
          ? (cadObject.surface_area * 1e-6 | number: "1.2-2")
          : "N/A"
      }}
      <span class="text-sm text-muted-color ml-1">m²</span>
    </div>
  </div>

  <!-- Bounding Box Dimensions -->
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">
      Bounding Box Dimensions
    </div>
    @if (cadObject.bounding_box_dimensions) {
      <div class="text-base">
        <div>
          Length (X):
          {{ cadObject.bounding_box_dimensions[0] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
        <div>
          Width (Y):
          {{ cadObject.bounding_box_dimensions[1] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
        <div>
          Height (Z):
          {{ cadObject.bounding_box_dimensions[2] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
      </div>
    } @else {
      <div class="text-base text-muted-color">N/A</div>
    }
  </div>

  <!-- Bounding Box Center -->
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">
      Bounding Box Center
    </div>
    @if (cadObject.center) {
      <div class="text-base">
        <div>
          X: {{ cadObject.center[0] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
        <div>
          Y: {{ cadObject.center[1] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
        <div>
          Z: {{ cadObject.center[2] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
      </div>
    } @else {
      <div class="text-base text-muted-color">N/A</div>
    }
  </div>

  <!-- Center of Mass -->
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">
      Center of Mass
    </div>
    @if (cadObject.center_of_mass) {
      <div class="text-base">
        <div>
          X: {{ cadObject.center_of_mass[0] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
        <div>
          Y: {{ cadObject.center_of_mass[1] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
        <div>
          Z: {{ cadObject.center_of_mass[2] | number: "1.2-2"
          }}<span class="text-sm text-muted-color ml-1">mm</span>
        </div>
      </div>
    } @else {
      <div class="text-base text-muted-color">N/A</div>
    }
  </div>

  <!-- Edge Lengths -->
  <div>
    <div class="text-sm font-semibold text-muted-color mb-1">Edge Lengths</div>
    <div class="text-base">
      <div>
        Outer:
        {{
          cadObject.outer_edge_length !== null
            ? (cadObject.outer_edge_length | number: "1.2-2")
            : "N/A"
        }}
        <span class="text-sm text-muted-color ml-1">mm</span>
      </div>
      <div>
        Cutout:
        {{
          cadObject.cutout_edge_length !== null
            ? (cadObject.cutout_edge_length | number: "1.2-2")
            : "N/A"
        }}
        <span class="text-sm text-muted-color ml-1">mm</span>
      </div>
      <div>
        Holes:
        {{
          cadObject.holes_edge_length !== null
            ? (cadObject.holes_edge_length | number: "1.2-2")
            : "N/A"
        }}
        <span class="text-sm text-muted-color ml-1">mm</span>
      </div>
    </div>
  </div>
</div>
